import type { IconSvgObject } from './types';

const ArrowDataTransferVerticalIcon: IconSvgObject = [
  ["path", { d: "M15 19.0002L15 4.99988L19 7.99988", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 4.99951L9 18.9998L5 15.9998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowDataTransferVerticalIcon;
